import React from 'react'
import { Switch, SwitchClassKey, SwitchProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string
  rootNoMargin?: string
}

interface YumSwitchProps extends SwitchProps {
  classes: Styles
  noMargin?: boolean
}

const YumSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '44px',
      height: '24px',
      padding: 0,
      margin: '7px 1px 7px 0',
      '&.MuiSwitch-sizeSmall': {
        width: '36px',
        height: '20px',
      },
    },
    switchBaseSmall: {
      padding: '2px',
    },
    rootNoMargin: {
      width: '44px',
      height: '24px',
      padding: 0,
      margin: '0 1px 0 0',
      transform: 'none !important', // Prevent rotation
      transition: 'none !important', // Disable the animation transition
    },
    switchBase: {
      padding: 2,
      '.MuiSwitch-sizeSmall &': {
        padding: '2px',
      },
      '&$checked': {
        transform: 'translateX(20px)',
        color: theme.palette.common.white,
        //color: theme.palette.primary.main,
        '& + $track': {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 'none',
        },
      },
      '&.Mui-disabled + $track': {
        opacity: '0.5 !important',
      },
      '&$focusVisible $thumb': {
        color: theme.palette.primary.main,
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 20,
      height: 20,
      boxShadow: 'none',
    },
    track: {
      borderRadius: '24px',
      // Unchecked track needs >=3:1 against the white thumb (WCAG 2.2 SC 1.4.11).
      // #cccccc gave 1.6:1; #707173 gives 4.9:1. Checked track stays primary blue.
      border: `1px solid #707173`,
      backgroundColor: '#707173',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }),
)(({ classes, noMargin, ...props }: YumSwitchProps) => {
  // Safety net so axe's `label` rule never fails on a nameless MuiSwitch input —
  // individual call sites should still pass a descriptive label via inputProps.
  const callerInputProps = (props.inputProps as any) || {}
  const callerAriaLabel = callerInputProps['aria-label'] || (props as any)['aria-label'] || 'Toggle'
  const mergedInputProps = {
    ...callerInputProps,
    'aria-label': callerAriaLabel,
    'data-a11y-label': callerInputProps['data-a11y-label'] || callerAriaLabel,
    // SRs should announce these as on/off switches, not plain checkboxes (WCAG 4.1.2).
    role: callerInputProps.role || 'switch',
  }
  return (
    <Switch
      color="default"
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: noMargin ? classes.rootNoMargin : classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
      inputProps={mergedInputProps}
    />
  )
})

export default YumSwitch
